import { Typography, TypographyProps } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { COLORS } from "../assets/colors";
import * as StyledUI from "./StyledUI";
export { default as Button } from "./Button";
export { default as PostContainer } from "./PostContainer";
export { default as PostActions } from "./PostActions";
export { default as FollowButton } from "./FollowButton";
export { default as JoinClubButton } from "./JoinClubButton";
export { default as JoinedClubButton } from "./JoinedClubButton";
export { default as Tab } from "./Tab";
export { default as Modal } from "./Modal";
export { default as SeeAllTitle } from "./SeeAllTitle";
export { StyledUI };
// export { default as ReactionModal } from "./ReactionModal";
export { default as FallbackLoader } from "./FallbackLoader";

export const SmallText = styled(Typography)`
  font-size: 12px;
  letter-spacing: 0.4px;
  font-weight: 600;
  color: ${COLORS.mutedDark};

  &.p-6 {
    padding: 6px;
  }

  a {
    text-decoration: none;
    font-weight: 800;
    color: ${COLORS.blue};

    &:hover {
      color: ${COLORS.lightBlue};
    }
  }
` as React.ComponentType<TypographyProps>;

export const Center = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`;

export const Cover = styled.div<{ cover: string }>`
  --radius: 8px;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
  height: var(--cover-height);
  width: 100%;
  ${({ cover }) =>
    cover &&
    `
    background-image: url(${cover});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  `}
`;

export const Container = styled.div`
  --radius: 8px;
  border-radius: 4px;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
  margin-bottom: 4px;
  background-color: var(--background-color-primary);
  box-shadow: var(--box-shadow);
`;

export const BoxContainer = styled.div`
  background: #fff;
  padding: 8px 12px 10px 12px;
  box-shadow: var(--box-shadow);
  border-radius: 4px;
  margin-top: 8px;
`;
